import { useEffect, useState } from "react"
import GlobalSpinner from "../globalsSpinner/GlobalSpinner";
import { PlayNowLog, PlayNowLogTypeEnum, downloadCSVPlayNowLogsData, getPlayNowLists, getPlayNowLogs } from "../../../api/playNowListApi";
import Select, { SingleValue } from "react-select";
import { Guid } from "../../../api/baseApi";
import { getPlayers } from "../../../api/playersApi";
import { convertUTCDateToLocalDate, getPastDateByDaysAgo, isFirstDateGreaterThanSecond } from "../../../services/dateService";
import Pagination from "../pagination/Pagination";
import fileDownload from "js-file-download";
import { getUsersList } from "../../../api/usersApi";
import { FormInput, FormRow } from "../formRow/FormRow";

type Option<T> = { value: T, label: string}

const PlayNowLogs = () => {
    let [isLoading, setIsLoading] = useState(false);
    let [playNowLogs, setPlayNowLogs] = useState<PlayNowLog[]>([]);
    let [players, setPlayers ] = useState<Option<Guid>[]>([]);
    let [playNow, setPlayNow ] = useState<Option<Guid>[]>([]);
    let [users, setUsers ] = useState<Option<Guid>[]>([]);
    let [selectedPlayer, setSelectedPlayer] = useState<Guid>('');
    let [selectedPlaylist, setSelectedPlaylist] = useState<Guid>('');
    let [selectedUser, setSelectedUser] = useState<Guid>('');
    let [selectedStartDate, setSelectedStartDate] = useState<string>("")
    let [isSelectedStartDateError, setIsSelectedStartDateError] = useState(false)
    let [selectedEndDate, setSelectedEndDate] = useState<string>(getPastDateByDaysAgo(0))
    let [isSelectedEndDateError, setIsSelectedEndDateError] = useState(false)
    let [currentPage, setCurrentPage] = useState<number>(1);
    let [totalPages, setTotalPages] = useState(1)

    let itemsPerPage = 20;


    useEffect(()=>{
        async function fetchProfiles(){
            setIsLoading(true);
            await Promise.all([updatePlayNowLogs(),updatePlayNowList(),updatePlayers(),updateUsers()]);
            setIsLoading(false);
        }

        fetchProfiles()
    },[])

    useEffect(() => {
        async function fetchData() {
            setIsLoading(true);
            await updatePlayNowLogs()
            setIsLoading(false);
        };
        
        fetchData()
    },[selectedPlayer, selectedPlaylist, selectedUser, selectedStartDate, selectedEndDate, currentPage])

    const updatePlayNowList = async () => {
        var result = await getPlayNowLists();
        if(result.type == 'succes'){
            let t = result.data.items.map( el => {
                return {
                    label: el.name,
                    value: el.id
                }
            })
            setPlayNow(t);
        }
    }

    const updatePlayers = async () => {
        var result = await getPlayers();
        let t = result.players.map( el => {
            return {
                label: el.name,
                value: el.id
            }
        })
        setPlayers(t);
    }

    const updateUsers = async () => {
        var result = await getUsersList();
        if(result.type === "succes") {
            let t = result.data.items.map(el => {
                return {label: el.name,value: el.id}
            })
            setUsers(t);
        }
    }

    const updatePlayNowLogs = async () => {
        let result = await getPlayNowLogs(selectedPlayer,selectedPlaylist, selectedUser, selectedStartDate, selectedEndDate, currentPage, itemsPerPage)
        if(result.type === "succes") {
            setPlayNowLogs(result.data.items)
            setTotalPages(result.data.totalPages)
        }
    }

    const onChangeSelectedPlaylist = (value: SingleValue<Option<Guid>>) => {
        if(value){
            setSelectedPlaylist(value.value);
        } else {
            setSelectedPlaylist('');
        }
        setCurrentPage(1)
    }

    const onChangeSelectedPlayer = (value: SingleValue<Option<Guid>>) => {
        if(value){
            setSelectedPlayer(value.value);
        } else {
            setSelectedPlayer('');
        }
        setCurrentPage(1)
    }

    const onChangeSelectedUser = (value: SingleValue<Option<Guid>>) => {
        if(value){
            setSelectedUser(value.value);
        } else {
            setSelectedUser('');
        }
        setCurrentPage(1)
    }

    const onStartDateChanged = (start: string) => {
        setSelectedStartDate(start);
        validateLogsPeriodDates(start, selectedEndDate)
    }

    const onEndDateChanged = (end: string) => {
        setSelectedEndDate(end);
        validateLogsPeriodDates(selectedStartDate, end)
    }

    const validateLogsPeriodDates = (start: string, end: string) => {
        if(isFirstDateGreaterThanSecond(start, end)){
            setIsSelectedEndDateError(true)
            setIsSelectedStartDateError(true)
        } else {
            setIsSelectedEndDateError(false)
            setIsSelectedStartDateError(false)
        }
    }

    const renderLogType = (logType: PlayNowLogTypeEnum) => {
        switch (logType) {
            case PlayNowLogTypeEnum.Activated:
            return <span style={{color:"#2DCC3D"}}>Activated</span>

            case PlayNowLogTypeEnum.Deactivated:
            return <span style={{color:"#F43257"}}>Deactivated</span>

            case PlayNowLogTypeEnum.Locked:
            return <span style={{color:"#2DCC3D"}}>Locked</span>

            case PlayNowLogTypeEnum.Unlocked:
            return <span style={{color:"#F43257"}}>Unlocked</span>
        
            default:
                break;
        }
    }

    const renderPlayNowLogs = (items: PlayNowLog[]) => {
        return items.map( item => {
            return <tr key={item.id}>
                <td>{renderLogType(item.playNowLogType)}</td>
                <td>{convertUTCDateToLocalDate(item.dateTime)}</td>
                <td>{item.playNowListName}</td>
                <td>{item.playerName}</td>
                <td>{item.actionDescription}</td>
                <td>{item.userName}</td>
            </tr>
        })
    }

    const downloadFile = async () => {
        let result = await downloadCSVPlayNowLogsData({
            playerId: selectedPlayer ? selectedPlayer : null,
            playlistId:selectedPlaylist ? selectedPlaylist: null,
            userId: selectedUser ? selectedUser : null,
            startDate: selectedStartDate ? selectedStartDate : null, 
            endDate: selectedEndDate ? selectedEndDate : null,
        })
        fileDownload(result.data, result.filename);
    }

    return (
        <>
            <div className="d-flex justify-content-end align-items-center mb-20 w-100 gap15 log-filters-block">
                <div className="w-300px abs-error">
                    <FormInput
                        errorMessage="Please select start date that earlier then end date"
                        id="log_start_date"
                        isError={isSelectedStartDateError}
                        type="date"
                        onChangeValue={(v) => {onStartDateChanged(v)}}
                        value={selectedStartDate}
                        title="Start"
                    />  
                </div>
                <div className="w-300px">
                    <FormInput
                        errorMessage=""
                        id="log_end_date"
                        isError={isSelectedEndDateError}
                        type="date"
                        onChangeValue={(v) => {onEndDateChanged(v)}}
                        value={selectedEndDate}
                        title="End"
                    />  
                </div>
                <div className="w-300px">
                    <label>Users</label>
                    <Select 
                        options={users}
                        classNamePrefix={`select`}
                        onChange={onChangeSelectedUser} 
                        isClearable={true}
                    />
                </div>
                <div className="w-300px">
                    <label>Playlists</label>
                    <Select 
                        options={playNow}
                        classNamePrefix={`select`}
                        onChange={onChangeSelectedPlaylist} 
                        isClearable={true}
                    />
                </div>
                <div className="w-300px">
                    <label>Players</label>
                    <Select 
                        options={players}
                        classNamePrefix={`select`}
                        onChange={onChangeSelectedPlayer} 
                        isClearable={true}
                    />
                </div>
                <div className="pt-20">
                    <a className="link-like__elem md" target="_blank" onClick={downloadFile}>Download CSV</a>
                </div>
            </div>

            <table className="table">
                <thead>
                    <tr>
                        <td>Action Type</td>
                        <td>Date Time</td>
                        <td>Playlist</td>
                        <td>Player</td>
                        <td>Action</td>
                        <td>User</td>
                    </tr>
                </thead>
                <tbody>
                    {renderPlayNowLogs(playNowLogs)}
                </tbody>
            </table>

            <Pagination activePage={currentPage} pagesCount={totalPages} aroundElements={2} changePaginationPage={setCurrentPage} />

            <GlobalSpinner isShow={isLoading} />
        </>
    )
}

export default PlayNowLogs